<template>
  <router-view />
</template>

<script setup lang="ts">
// Root component - router-view handles routing
</script>

<style scoped>
/* Root component styles */
</style>